export default __webpack_public_path__ + "static/1243-5d11de9bcac1eee2d39f1f9fda8e0b3a.gif";